var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporationIconHomepage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2c3530"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.5 712.5v450h187.5v-450zm93.75 150c-20.625 0-37.5-16.875-37.5-37.5s16.875-37.5 37.5-37.5 37.5 16.875 37.5 37.5-16.875 37.5-37.5 37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.5 487.5h56.25v37.5h-56.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.5 337.5h56.25v37.5h-56.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.5 412.5h56.25v37.5h-56.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.5 562.5h56.25v37.5h-56.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.5 637.5h56.25v37.5h-56.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600 37.5v112.5h262.5v37.5h-150v37.5h150v37.5h-150v37.5h187.5v-262.5zm262.5 75h-225v-37.5h225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m845.62 742.5c1.875 1.875 3.75 5.625 5.625 7.5h217.5v37.5h-208.12c0 5.625 0 11.25-1.875 16.875l-3.75 16.875c0 1.875-1.875 1.875-1.875 3.75h215.62v37.5h-225v-16.875c-9.375 16.875-22.5 31.875-37.5 41.25l5.625 1.875c16.875 3.75 33.75 5.625 50.625 5.625 9.375 0 16.875 0 26.25-1.875l97.5-13.125 84.375-20.625c9.375-3.75 20.625-5.625 30-5.625h3.75v-515.62h-298.12v376.88c15 3.75 30 13.125 39.375 28.125zm-1.875-367.5h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.75 656.25c35.625 0 71.25 5.625 103.12 18.75h110.62v28.125l37.5 1.875v-517.5h-300v476.25c16.875-5.625 33.75-7.5 48.75-7.5zm-11.25-431.25h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225zm0 75h225v37.5h-225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.6 958.12-3.75-20.625c-3.75-15-15-28.125-28.125-35.625s-30-7.5-45-1.875l-90 18.75-101.25 13.125c-30 3.75-60 1.875-90-5.625l-138.75-33.75 91.875-24.375c30-5.625 54.375-26.25 61.875-56.25l3.75-16.875c1.875-11.25 0-22.5-5.625-31.875-7.5-9.375-16.875-15-28.125-15l-204.38-11.25c-13.125 0-24.375-3.75-35.625-11.25-35.625-20.625-78.75-31.875-123.75-31.875-60 0-123.75 43.125-161.25 73.125v286.88l339.38 50.625c11.25 1.875 24.375 1.875 35.625 1.875h165c15 0 31.875-1.875 46.875-3.75l146.25-28.125c16.875-3.75 33.75-9.375 50.625-18.75l101.25-56.25c11.25-9.375 16.875-26.25 13.125-41.25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporationIconHomepage);
export default __webpack_public_path__ + "static/media/corporation-icon-homepage.778e57aa34263edba42405f42dc7c56e.svg";
export { ForwardRef as ReactComponent };